import https from 'https';
import PUBLIC from "~/public-routes";
// @ts-ignore
import { Plugin } from '@nuxt/types'
import { BaseApiResponse } from "~/interfaces/general";

// @ts-ignore
declare module 'vue/types/vue' {
  interface Vue {
    $api(action: string, data?: object | FormData, method?: string): Promise<any>
  }
}
// @ts-ignore
declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $api(action: string, data?: object | FormData, method?: string): Promise<any>
  }
  interface Context {
    $api(action: string, data?: object | FormData, method?: string): Promise<any>
  }
}
// @ts-ignore
declare module 'vuex/types/index' {
  interface Store<S> {
    $api(action: string, data?: object | FormData, method?: string): Promise<any>
  }
}

interface Headers {
  [key: string]: string
}

interface Process {
  server: boolean
}

declare var process: Process;

const Plugin: Plugin = (context: any, inject: any) => {
  inject('api', (action: string, data: object | FormData = {}, method: string = "GET") => {
    let $axios = context.$axios;
    let $auth = context.$auth;
    return new Promise( (resolve, reject) => {
      const TOKEN = $auth.strategy.token.get();
      //const R_TOKEN = $auth.strategy.refreshToken.get();
      let params = {
        __METHOD: method,
        action: action
      };
      // @ts-ignore
      //data.refresh_token = R_TOKEN;
      let contentType = '';

      if (typeof data === 'object') {
        contentType = 'application/json';
      } else {
        contentType = 'multipart/form-data';
      }
      //console.log('api data before:', data, params);
      if (method === "GET" || process.server) {
        params = Object.assign(params, data);
        data = {};
      }
      //console.log('api data after:', data, params);

      let headers: Headers = {
        'Content-Type': contentType,
        'Authorization': 'Bearer'
      };

      if (typeof TOKEN === 'string' && TOKEN.length > 0) {
        headers['Authorization'] = TOKEN;
      }

      $axios({
        method: 'post',
        data: data,
        params: params,
        headers: headers,
        httpsAgent: new https.Agent({ rejectUnauthorized: false }) // при рабочем сертификате убрать
      })
        .then((response: BaseApiResponse) => {
          if (response.data) {
            const CODE = Number(response.data.code);
            if (CODE >= 400 && CODE < 500) {
              const route = context.app.router.history.current.path;
              let isPublic = PUBLIC.some((el: string) => route.includes(el));
              if (CODE === 401 && !isPublic) {
                $auth.logout();
                return context.redirect('/auth/adfs/');
              }
              reject(response.data);
            } else if (CODE >= 500) { // Возможность обработки серверных ошибок отдельно
              reject(response.data);
            } else {
              return resolve(response.data);
            }

          }
          return reject("Не удалось установить соединение с API");
        })
        .catch((error: any) => {
          return reject({code: error.response.status, data: {response: error.response}, message: "Неожиданная ошибка"});
          /*if (error.response && error.response.data) {
            let errorResponse = error.response.data;
            if (errorResponse.code !== 'undefined') {
              if (errorResponse.code === 401 && !context.app.router.history.current.path.includes('auth')) {
                //console.log('logout need', data, params);
                $auth.logout();
                return context.redirect('/auth/adfs/');
              }
            }
            if (error.response.data) {
              return reject(error.response.data);
            }
            return reject(error.response);
          } else {
            return reject("Неожиданная ошибка");
          }*/

        });

    });
  })
}

export default Plugin
